import React, { useEffect } from 'react';
import ReactGA from 'react-ga';
import TagManager from 'react-gtm-module'
import ReactPixel from 'react-facebook-pixel';

import Header from '../../components/Header';
import Footer from '../../components/Footer';
import { Switch, Route, Redirect, useHistory, useLocation, useRouteMatch, withRouter } from 'react-router-dom';

import CategoriasContainer from '../../containers/CategoriasContainer';
import VersionContainer from '../../containers/VersionContainer';
import './App.scss';
import ColorContainer from '../../containers/ColorContainer';
import ExtrasContainer from '../../containers/ExtrasContainer';
import MaintenancesContainer from '../../containers/MaintenancesContainer';
import InsuranceContainer from '../../containers/InsuranceContainer';
import PurchaseContainer from '../../containers/PurchaseContainer';
import SummaryContainer from '../../containers/SummaryContainer';
import TestDriveContainer from '../../containers/TestDriveContainer';
import AvaluoContainer from '../../containers/AvaluoContainer';
import AvaluoGraciasContainer from '../../containers/AvaluoGraciasContainer';
import PurchaseConfirmationContainer from '../../containers/PurchaseConfirmationContainer';
// import TestDriveConfirmationContainer from '../../containers/TestDriveConfirmationContainer';
import { CAMPAINGS, DEFAULT_FIRST_TYPE } from '../../utils/constants';
import {
  VirtualTourProvider,
  VirtualTourConsumer,
} from '../../utils/VirtualTourContext';
import VirtualTour from '../VirtualTour/VirtualTour';
import FinanceContainer from '../../containers/FinanceContainer';
import CotizarContainer from '../../containers/CotizarContainer/CotizarContainer';
import bem from '../../utils/bem';
import { useHeader, usePrevious, useQuery } from '../../utils/hooks';
import { scrollToTop } from '../../utils/helpers';
import { useState } from 'react';
import { useCallback } from 'react';
// import expoFlotante from '../../images/expo-flotante.png';
import Pixel from '../Pixel';
import PurchaseProcessing from '../Purchase/PurchaseProcessing';

const ScrollToTop = () => {
  const location = useLocation();
  const prevLocation = usePrevious(location);
  const match = useRouteMatch("/:tipo");
  useEffect(() => {
    if (location?.pathname !== prevLocation?.pathname) {
      if (!match?.isExact) {
        scrollToTop(300);
      }
    }
  }, [location, match, prevLocation]);
  return <React.Fragment />
}

const ScrollToTopC = withRouter(ScrollToTop);

export const InnerContext = ({
  activeCampaign,
  setActiveCampaign
}) => {
  const query = useQuery();
  const campaign = query.get('utm_campaign');
  useEffect(() => {
    if (CAMPAINGS[campaign]) {
      setActiveCampaign(campaign)
    }
  }, []);

  return (
    <></>
  );
}

const AppContainer = ({ saveQueryParams }) => {
  const history = useHistory();
  const location = useLocation();
  const match = useHeader();
  const [searchParams] = useState(window.location?.search);

  const matchSummary = useRouteMatch('/:tipo/:modelo/:version/:anio/:color/resumen/');

  const trackPageView = useCallback(() => {
    ReactPixel.pageView();
    const dataLayer = window.dataLayer || [];
    dataLayer.push({ event: 'pageview' });
    ReactGA.pageview(window.location.pathname + searchParams);
  }, [searchParams]);

  useEffect(() => {
    const tagManagerArgs = {
      gtmId: 'GTM-P5LJ7MR',
      events: {
        pageview: 'pageview'
      }
    }

    TagManager.initialize(tagManagerArgs);
    ReactGA.initialize('UA-70309507-1');
    ReactPixel.init('1992744307699937');
    trackPageView(searchParams);
    history.listen(() => {
      trackPageView(searchParams);
    });
  }, [history, searchParams, trackPageView]);

  useEffect(() => {
    saveQueryParams(location?.search);
    //saveHubInformationIfAvailable();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  //   +  const history = useHistory();
  // +
  // +  React.useEffect(() => {
  // +    trackPageView(); // To track the first pageview upon load
  // +    history.listen(trackPageView); // To track the subsequent pageviews
  // +  }, [history]);
  // +
  // +  function trackPageView() {
  // +    ga("set", "page", window.location.pathname);
  // +    ga("send", "pageview");
  // +  }

  return (
    <div className="App">
      <ScrollToTopC />
      <Header isHome={match} />
      <VirtualTourProvider>
        <VirtualTourConsumer>
          {({ tourUrl, setTourUrl, activeCampaign, setActiveCampaign }) => {
            return (
              <div className={bem('App__content', {
                'is-not-home': !match,
                'is-summary': matchSummary
              })}>
                <InnerContext activeCampaign={activeCampaign} setActiveCampaign={setActiveCampaign} />
                <Switch>
                  {/* <Route path="/test-drive/reserva/:reservationId">
                    <TestDriveConfirmationContainer />
                  </Route>
                  <Route path="/test-drive/">
                    <TestDriveContainer />
                  </Route> */}
                  <Route path="/avaluo/gracias/">
                    <Pixel key={16} />
                    <AvaluoGraciasContainer />
                  </Route>
                  <Route path="/avaluo/">
                    <Pixel key={15} />
                    <AvaluoContainer />
                  </Route>
                  <Route path="/:tipo/:modelo/:version/:anio/:color/test-drive/">
                    <Pixel key={14} />
                    <TestDriveContainer />
                  </Route>
                  <Route path="/reserva/:reservationId/">
                    <Pixel key={13} />
                    <PurchaseConfirmationContainer />
                  </Route>
                  <Route path="/:tipo/:modelo/:version/:anio/:color/reservar/procesando">
                    <Pixel key={17} />
                    <PurchaseContainer showProcessingScreen={true} />
                  </Route>
                  <Route path="/:tipo/:modelo/:version/:anio/:color/reservar/">
                    <Pixel key={12} />
                    <PurchaseContainer />
                  </Route>
                  <Route path="/:tipo/:modelo/:version/:anio/:color/cotizar/gracias-por-cotizar">
                    <Pixel key={11} />
                    <CotizarContainer isConfirmation={true} />
                  </Route>
                  <Route path="/:tipo/:modelo/:version/:anio/:color/cotizar/">
                    <Pixel cotizar={true} key={10} />
                    <CotizarContainer />
                  </Route>
                  <Route path="/:tipo/:modelo/:version/:anio/:color/resumen/">
                    <Pixel resumen={true} key={9} />
                    <SummaryContainer />
                  </Route>
                  <Route path="/:tipo/:modelo/:version/:anio/:color/seguros/">
                    <Pixel key={8} />
                    <InsuranceContainer />
                  </Route>
                  <Route path="/:tipo/:modelo/:version/:anio/:color/financiamiento/">
                    <Pixel key={7} />
                    <FinanceContainer />
                  </Route>
                  <Route path="/:tipo/:modelo/:version/:anio/:color/accesorios/">
                    <Pixel key={6} />
                    <ExtrasContainer />
                  </Route>
                  <Route path="/:tipo/:modelo/:version/:anio/:color/mantenimientos/">
                    <Pixel key={5} />
                    <MaintenancesContainer />
                  </Route>
                  <Route path="/:tipo/:modelo/:version/:anio/">
                    <Pixel key={4} />
                    <ColorContainer />
                  </Route>
                  <Route path="/:tipo/:modelo/:version/">
                    <Pixel key={3} />
                    <VersionContainer />
                  </Route>
                  <Route path="/:tipo/:modelo">
                    <Pixel modelo={true} key={2} />
                    <VersionContainer />
                  </Route>
                  <Route path="/:tipo/">
                    <Pixel tipo={true} key={1} />
                    <CategoriasContainer />
                  </Route>
                  {/* <Route path="/">
                    <CategoriasContainer />
                  </Route> */}
                  <Redirect from="/" to={`/${DEFAULT_FIRST_TYPE}/${location?.search}`} />
                </Switch>
                {tourUrl && (
                  <VirtualTour
                    tourUrl={tourUrl}
                    onClose={() => setTourUrl(null)}
                  />
                )}
              </div>
            );
          }}
        </VirtualTourConsumer>
      </VirtualTourProvider>
      {/* UNCOMMENT FOR EXPO 2022 */}
      {/* <a className='expo-flotante' href="https://expo.veinsamotors.com" target="_blank">
        <img src={expoFlotante} alt="Expomovil" />
      </a> */}
      <Footer />
    </div>
  );
};

export default AppContainer;
